import React, { useEffect } from 'react';
import { LoggerModule } from '@vlinder-web/logger-module-react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let RejectedDocsApplicantMachine: any;

const MODULE_NAME = 'machines.RejectedDocsApplicant';
const log: any = LoggerModule?.getInstance();

export const useSMRejectedDocsApplicant = (_context: any) => {
  console.log('qqqmachineentered');
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  RejectedDocsApplicantMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(RejectedDocsApplicantMachine);

  return {
    RejectedDocsApplicantMachine,
    RejectedDocsApplicantState: state,
    RejectedDocsApplicantSend: send,
  };
};
